import SearchAndSelectTemplate from './search-and-select.html';
import './search-and-select.scss';

let SearchAndSelectDirective = ['$rootScope', '$translate', ($rootScope, $translate) => {
    var
        DEFAULT_SELECTED_ITEMS = 'Selected: ',
        DEFAULT_NO_SELECTION = $translate.instant('common.none'),
        OFFSET_VALUE = 10,
        IS_EDIT_OFFSET_VALUE = 11;

    return {
        require: 'ngModel',
        replace: true,
        restrict: 'E',
        scope: {
            values: "=",
            selecteditem: "=ngModel",
            key: "@",
            onscroll: "&",
            totalrecords: "=",
            noneSelected: "=",
            commonSearchFlag: "=",
            longDdWidthFlag: "=",
            onClick: "&",
            hideCount: "=",
            isEdit: '=',
            setId: '@',
            isChangeOffset: '=',
            isChangeOffsetValue: '=',
            focusDropdownId: '@',
            focusDropdownSearch: '@',
            extendDdWidth: "=",
            updatedValues: "=",
            isHighlighted: "="
        },
        templateUrl: 'search-and-select.html',
        link: function (scope, elm, attrs) {
            let allValues = [];
            scope.focusedIdx =  0;
            scope.dropdownVisible = false;
            scope.prevOffset = 0;
            scope.filteredValues = [];
            scope.ignoreOutsideClickUntil = 0;
            setTimeout(function(){ allValues = scope.values; }, 3000);
            if (!attrs.setId) {
                scope.setId = 'searchString'
            }
            // Observer require field
            attrs.$observe('required', function (value) {
                scope.required = !!value;
            });

            attrs.$observe('disabled', function (value) {
                scope.disabled = !!value;
            });

             scope.$watch('values', function (newValues) {
                if (newValues && Array.isArray(newValues)) {
                    allValues = [...newValues];
                    scope.filteredValues = [...allValues];
                    if ((newValues.length || 0) <= OFFSET_VALUE) {
                        scope.prevOffset = 0;
                    }
                }
            });

            // Check require or not
            scope.isValid = function () {
                return !!scope.required ? (!!scope.selecteditem) : true;
            };

            scope.itemIsActive = function (item) {
                return scope.selecteditem && item.Value === scope.selecteditem.Value;
            };

            scope.currentLabel = function updateLabel() {
                var
                    tag = 'span',
                    allItems = [scope.selecteditem] || [],
                    selPrefix = scope.selectedPrefix || DEFAULT_SELECTED_ITEMS,
                    noSelection = $translate.instant(scope.noneSelected) || DEFAULT_NO_SELECTION,
                    label = '';
                if (scope.selecteditem != null) {
                    for (var i = 0; i < allItems.length; i++) {
                        if (scope.itemIsActive(allItems[i])) {
                            label = allItems[i].Key;
                        }
                    }
                }

                if (!label) {
                    if (scope.selecteditem == null || scope.selecteditem == "" || scope.selecteditem == undefined) {
                        label = scope.wrapTag(noSelection, tag);
                        scope.selecteditem = null;
                    }
                }
                return label;
            };

            scope.wrapTag = function (content, tag) {
                return '<' + tag + '>' + content + '</' + tag + '>';
            }

            scope.selectItem = function (item) {
                if (scope.selecteditem) {
                    if (item[scope.key] === scope.selecteditem[scope.key]) {
                        scope.selecteditem = null;
                        scope.textChanged(scope.searchKey);
                        scope.showList = true;
                    } else {
                        scope.selecteditem = item;
                        scope.showList = false;
                        if(!scope.commonSearchFlag){
                            if(scope.searchKey && scope.searchKey.length > 0){
                                scope.searchKey = '';
                                scope.prevOffset = 0;
                                scope.onscroll({
                                    searchKey: scope.searchKey,
                                    offset: 0
                                });
                            }
                        }else{
                            if(scope.searchKey){
                                scope.searchKey = '';
                                scope.totalrecords = allValues.length;
                                scope.values = allValues;
                                scope.filteredValues = allValues;
                            }
                        }
                    }
                } else {
                    scope.selecteditem = item;
                    scope.showList = false;
                    if(!scope.commonSearchFlag){
                        if(scope.searchKey && scope.searchKey.length > 0){
                            scope.searchKey = '';
                            scope.prevOffset = 0;
                            scope.onscroll({
                                searchKey: scope.searchKey,
                                offset: 0
                            });
                        }
                    }else{
                        if(scope.searchKey){
                            scope.searchKey = '';
                            scope.totalrecords = allValues.length;
                            scope.values = allValues;
                            scope.filteredValues = allValues;
                        }
                    }
                }
            };

            scope.isActive = function (item) {
                if (scope.selecteditem) {
                    return item[scope.key] === scope.selecteditem[scope.key];
                }
                else {
                    return false;
                }
            };

            scope.textChanged = function (searchKey) {
                const updatedValues = _.cloneDeep(scope.updatedValues || []); 
                
                if (allValues.length === 0) {
                    allValues = scope.values.slice();
                }

                if (scope.commonSearchFlag) {
                    if (!searchKey || searchKey.trim() === "") {               
                        scope.filteredValues = [...allValues];
                        scope.totalrecords = allValues.length;
                    } else {
                        const filtered = allValues.filter(item =>
                            item.Key.toLowerCase().includes(searchKey.toLowerCase())
                        );
                        scope.filteredValues = filtered;
                        scope.totalrecords = filtered.length;
                      }
                } else {
                    scope.prevOffset = 0;
                    scope.ignoreOutsideClickUntil = Date.now() + 500;
                    scope.onscroll({
                        searchKey: searchKey,
                        offset: 0
                    });
                }
            };

            function setDDHeight(){
                if(scope.values && scope.values.length < 9){
                    if(scope.hideCount){
                        $(".dropdownone").css("max-height", 100 + (scope.values.length * 30));
                    }
                }else{
                    $(".dropdownone").css("max-height", 'none');
                }
            }
          
            scope.close = function () {
                setTimeout(() => {
                    if (scope.ignoreOutsideClickUntil && Date.now() < scope.ignoreOutsideClickUntil) {
                        return;
                    }
                    if (!scope.showList) {
                        scope.filteredValues = allValues;
                    }
                    scope.focusedIdx = 0;
                    scope.hideDropdown();
                }, 100)
            }

            scope.show = function () {
                if(allValues && allValues.length === 0){
                    allValues = scope.values;
                }
                setDDHeight();
                scope.focusedIdx =  0;
                scope.showList = true;
                scope.showDropdown();
                if ((!scope.searchKey || scope.searchKey.length === 0) && (scope.values && scope.values.length <= OFFSET_VALUE)) {
                    scope.prevOffset = 0;
                    scope.offset = 0;
                }
                if ((!scope.searchKey || scope.searchKey.length === 0) && (scope.values && scope.values.length <= OFFSET_VALUE)) {
                    scope.prevOffset = 0;
                }
                scope.userScrolled = false;
                const cont = elm.find('.inner-item');
                if (cont && cont.length) cont.scrollTop(0);
            };
            scope.setActive = function(itemIndex) {
                scope.focusedIdx = itemIndex;
            };

            scope.dropdownPressed = function () {
                scope.pressedDropdown = true;
            }

            scope.showDropdown = function () {
                scope.dropdownVisible = true;
                setTimeout(() => {
                    const searchInput = elm.find('.search input');
                    if (searchInput && searchInput.length) {
                        searchInput.focus();
                    }
                }, 100)
            };
            
            scope.hideDropdown = function () {
                scope.dropdownVisible = false;
            }

           scope.selectPreviousItem = function() {
                let prevIndex = scope.focusedIdx - 1;
                if (prevIndex >= 0) {
                  scope.focusedIdx = prevIndex;
                }
              };
        
              scope.selectNextItem = function() {
                let nextIndex = scope.focusedIdx + 1;
                if (nextIndex < scope.values.length) {
                  scope.focusedIdx = nextIndex;
                }
              };
              
              scope.selectActiveItem = function () {
                if (scope.focusedIdx >= 0 && scope.focusedIdx < scope.values.length) {
                    scope.selectItem(scope.values[scope.focusedIdx]);
                  }
                  
            }            
            $rootScope.$on("documentClicked", function (inner, target) {

                var isSearchBox = ($(target[0]).is(".searchandselect")) || ($(target[0]).parents(".searchandselect").length > 0);
                if (!isSearchBox)
                    scope.$apply(function () {
                        scope.showList = true;
                    });
            });
            setTimeout(() => {
            const inner = elm.find(".inner-item");
            const menu = elm.find(".dropdownone");
            inner.on('wheel touchmove', function(){
                scope.userScrolled = true;
                scope.ignoreOutsideClickUntil = Date.now() + 800;
            });
            // Mark active interaction on scrollbar drag
            inner.on('mousedown', function(){
                scope.ignoreOutsideClickUntil = Date.now() + 800;
            });
            menu.on('mousedown', function(){
                scope.ignoreOutsideClickUntil = Date.now() + 800;
            });

            inner.bind('scroll', function () {
                var currentItem = $(this);
                if (!scope.userScrolled && currentItem && currentItem.length && currentItem[0].scrollTop > 0) {
                    scope.userScrolled = true;
                }
                const atBottom = (currentItem[0].scrollHeight - 1 <= currentItem[0].scrollTop + $(currentItem[0]).height() + 1);
                if (scope.userScrolled && atBottom) {
                    if (scope.values.length !== scope.totalrecords) {
                        setDDHeight();
                        if(scope.isEdit){
                            if (scope.values.length <= IS_EDIT_OFFSET_VALUE) scope.offset = 0;
                        }else{
                            if (scope.values.length <= OFFSET_VALUE) if(!scope.hideCount) scope.offset = 0;
                        }
                        if (scope.offset == undefined || scope.offset == 0) {
                            if(!scope.hideCount) scope.offset = scope.values.length || OFFSET_VALUE;
                            else scope.offset = OFFSET_VALUE;
                        }
                        else {
                            scope.offset = scope.values && scope.values.length ? scope.values.length : scope.offset + OFFSET_VALUE;
                        }
                        if (scope.prevOffset == scope.offset) { return }
                        scope.prevOffset = scope.offset;
                        scope.ignoreOutsideClickUntil = Date.now() + 800;
                        if(scope.isChangeOffset) {
                            if(scope.isChangeOffsetValue <= scope.totalrecords){
                                scope.onscroll({
                                    searchKey: scope.searchKey,
                                    offset: scope.offset
                                });
                            }
                        }else{
                            if(scope.offset <= scope.totalrecords){
                                scope.onscroll({
                                    searchKey: scope.searchKey,
                                    offset: scope.offset
                                });
                            }
                        }
                    }
                }
            });
            }, 50)
            elm.find(".dropdownone .inner-item").bind('click', function () {
                scope.$apply(function () {
                    scope.onClick();
                })
            })

            $(document).mouseup(function (e) {
                var $menu = $('.dropdownone');
                const isOutside = (!$menu.is(e.target) && $menu.has(e.target).length == 0);
                if (isOutside)
                {
                    scope.$apply(function () {
                        if (scope.ignoreOutsideClickUntil && Date.now() < scope.ignoreOutsideClickUntil) {
                            return;
                        }
                        if(scope.showList == true){
                            scope.showList = false;
                            if(!scope.commonSearchFlag){
                                if(scope.searchKey && scope.searchKey.length > 0){
                                    scope.searchKey = '';
                                    scope.prevOffset = 0;
                                    scope.onscroll({
                                        searchKey: scope.searchKey,
                                        offset: 0
                                    });
                                }
                            }else{
                                if(scope.searchKey){
                                    scope.searchKey = '';
                                    scope.totalrecords = allValues.length;
                                    scope.values = allValues;
                                    scope.filteredValues = allValues;
                                }
                            }
                        }
                    });
               }
            });
            
            elm.bind("keydown keypress", function (event) {

                let targetElement = $(event.currentTarget).find('.inner-item');
                switch (event.which) {
                    case 38:
                        event.preventDefault();
                        $($(targetElement)).scrollTop(0);
                        $($(targetElement)).scrollTop($(event.currentTarget).find('.highlight-row:first').position().top - $(event.currentTarget).parent().position().top -100 );
                        scope.$apply(scope.selectPreviousItem());
                        break;
                    case 40:
                        event.preventDefault();
                        $($(targetElement)).scrollTop(0);
                        $($(targetElement)).scrollTop($(event.currentTarget).find('.highlight-row:first').position().top - $(event.currentTarget).parent().position().top - 30 );
                        scope.$apply(scope.selectNextItem());
                        break;
                    case 13:
                        if (scope.dropdownVisible && scope.values && scope.values.length > 0) {
                            event.preventDefault();
                            scope.$apply(scope.selectActiveItem());
                        }
                        break;
                }
            });
        }
    };
}];

export default SearchAndSelectDirective;







// WEBPACK FOOTER //
// ./client/app/common/search-and-select/search-and-select.directive.js